const Checkmark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11.965" height="8.634" viewBox="0 0 11.965 8.634"><path d="M391,12.983a.65.65,0,0,1-.46-.19L387.207,9.46a.65.65,0,0,1,.919-.919L391,11.414l6.873-6.874a.65.65,0,1,1,.919.919l-7.333,7.333A.65.65,0,0,1,391,12.983Z" transform="translate(-387.018 -4.35)" fill="#222" /></svg>
);

export default Checkmark;
